module.exports = __webpack_public_path__ + "static/media/Incorrect-icon.3ba65327.svg";